import React, { useEffect, useState } from "react";
import { Grid, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import validateColor from "../../../../utils/colorValidation";

const DEFAULT_DESIGN = "https://via.placeholder.com/200x400";
const INIT_FORM_DATE = {
	title: "",
	backgroundImageUrl: "",
	isDeleted: false,
	screenBackgroundColor: "#000000",
	textColor: "#ffffff",
	cardBackgroundColor: "#000000",
	order: "0",
};
const INIT_ERRORS = {
	title: "",
	textColor: "",
	cardBackgroundColor: "",
	screenBackgroundColor: "",
};

const AddGiftWrapperModal = ({ isVisible, onClose, onCreate, existingFormData }) => {
	const theme = useTheme();

	const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState(INIT_FORM_DATE);
	const [backgroundImage, setBackgroundImage] = useState(DEFAULT_DESIGN);
	const [image, setImage] = useState(null);

	useEffect(() => {
		if (existingFormData) {
			setFormData(existingFormData);
			setBackgroundImage(existingFormData.backgroundImageUrl || existingFormData.backgroundImageUrlGcp);
		}
	}, [existingFormData]);

	const handleCloseModal = () => {
		setBackgroundImage(DEFAULT_DESIGN);
		setErrors(INIT_ERRORS);
		setFormData(INIT_FORM_DATE);
		onClose(false);
	};

	const validateField = (name, value) => {
		console.log("validateField", { name, value });
		switch (name) {
			case "title":
				setErrors((prevState) => ({
					...prevState,
					title: value ? "" : "Design name is required.",
				}));
				break;
			case "textColor":
				setErrors((prevState) => ({
					...prevState,
					textColor: validateColor(value) ? "" : "Invalid color code.",
				}));
				break;
			case "screenBackgroundColor":
				setErrors((prevState) => ({
					...prevState,
					screenBackgroundColor: validateColor(value) ? "" : "Invalid color code.",
				}));
				break;
			case "cardBackgroundColor":
				setErrors((prevState) => ({
					...prevState,
					cardBackgroundColor: validateColor(value) ? "" : "Invalid color code.",
				}));
				break;
			default:
				break;
		}
	};

	const handleImageChange = (event) => {
		setErrors((prevState) => ({
			...prevState,
			image: "",
		}));

		const file = event.target.files[0];
		setImage(event.target.files[0]);
		const reader = new FileReader();
		reader.onload = () => {
			setBackgroundImage(reader.result);
		};
		if (file) {
			reader.readAsDataURL(file);
		}
	};

	const handleInputChange = (event) => {
		const { id, value } = event.target;
		setFormData((prevState) => ({
			...prevState,
			[id]: value,
		}));
		validateField(id, value);
	};

	const inputProps = {
		required: true,
		fullWidth: true,
		margin: "normal",
		onChange: handleInputChange,
	};

	const onCreateHandler = () => {
		const items = Object.keys(formData);
		items.forEach((item) => {
			validateField(item, formData[item]);
		});

		if (!isUpdate && !image) {
			setErrors((prevState) => ({
				...prevState,
				image: "Image is required",
			}));
		}

		const allFieldsOk = Object.values(errors).every((x) => x === null || x === "");
		console.log({ allFieldsOk, errors });

		if (allFieldsOk) {
			onCreate({ ...formData, image, isUpdate });
			handleCloseModal();
		}
	};

	return (
		<Dialog open={isVisible} onClose={onClose} fullScreen={fullScreen} scroll="paper">
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				New Gift Design
			</DialogTitle>
			<DialogContent dividers>
				<Grid container rowSpacing={50}>
					<Grid item md={6} xs={12}>
						<img src={backgroundImage} width={"90%"} height={"90%"} alt="Gift design" loading="lazy" />
						<input type="file" name="image" accept="image/*" width={"90%"} height={"90%"} onChange={handleImageChange} />
						{errors.image && <span style={{ color: "#d32f2f" }}>{errors.image}</span>}
					</Grid>
					<Grid item md={6} xs={12}>
						<TextField {...inputProps} id="title" label="Design name" value={formData.title} error={!!errors.title} helperText={errors.title} />
						<TextField {...inputProps} id="textColor" label={`Text color (${formData.textColor})`} value={formData.textColor} type="color" />
						<TextField {...inputProps} id="screenBackgroundColor" label={`Screen background color (${formData.screenBackgroundColor})`} value={formData.screenBackgroundColor} type="color" />
						<TextField {...inputProps} id="cardBackgroundColor" label={`Card background color (${formData.cardBackgroundColor})`} type="color" value={formData.cardBackgroundColor} />
						<TextField {...inputProps} id="order" label="Display order" type="number" value={formData.order} />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button variant="contained" onClick={onCreateHandler} disabled={!formData.title || (!isUpdate && !image)}>
					{isUpdate ? "Update" : "Create"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddGiftWrapperModal;
